// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transit-hint[data-v-100eebb0]{grid-column:1;grid-row:2}.transit-hint .hint[data-v-100eebb0]{position:absolute;top:0;left:0;font-style:italic;font-size:12px}", ""]);
// Exports
module.exports = exports;
